import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { Spin } from "antd";

import { Col, Form, Row, Card, Table } from "react-bootstrap";
import { Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import PsContext from "../../context";
import {
  MOB_ICONS,
  momentDate,
  upperCase,
  S3_BUCKET_HOME_PATH,
  siteUrl,
  ParseFloat,
  groupByMultiple,
  semesterValue,
} from "../../utils";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import ModuleAccess from "../../context/moduleAccess";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";
import { APP_TYPE, baseUrl } from "../../utils";
import PrintPdf from "./printpdf";
import PsModalWindow from "../../utils/PsModalWindow";
import { CheckCircleOutline } from "antd-mobile-icons";
import Captcha from 'react-captcha-code';

const ExamResults = (props) => {
  const context = useContext(PsContext);

  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [isValid, setIsValid] = useState(null);
  const captchaRef = useRef(null);

  const [showAdd, setShowAdd] = useState(false);
  const [profile, setProfile] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [printReport, setPrintReport] = useState(false);
  const [dayOrders, setDayOrders] = useState([]);
  const [myData, setMyData] = useState([]);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    loadResultData();
  }, []);

  const loadResultData = () => {
    //setLoader(true);
    setDataList([]);
    const form = new FormData();
    axios.post(ServiceUrl.STUDENTS.LIST_EXAM_RESULTS_DATA).then((res) => {
      if (res["data"].status == "1") {
        var data = res["data"].data;
        setDataList(data);
        //loadData(data[0].exam_month);
      } else {
        toast.error(res["data"].message || "Error");
        // setLoader(false);
      }
    });
  };

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    //form.append("exam_month", exam_month);
    axios
      .post(ServiceUrl.STUDENTS.LIST_EXAM_RESULTS, form)
      .then((res) => {
        if (res.data.status === "1") {
          setViewData(res.data.data);
          // console.log('test', res.data.data);
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
        setLoader(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoader(false);
      });
  };
  const downloadFile = () => {
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);

    axios
      .post(ServiceUrl.STUDENTS.LIST_EXAM_RESULTS_PDF, form, {
        responseType: "blob",
      })
      .then((res) => {
        if (res.data) {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(pdfBlob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            context.user.registerno + "- Result .pdf"
          );

          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        } else {
          toast.error("No PDF data received.");
        }
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
        toast.error("Error fetching PDF.");
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleRefresh = () => {
    captchaRef.current.refresh();
  };

  // Handle CAPTCHA value change
  const handleCaptchaChange = useCallback((value) => {
    setCaptchaValue(value);
    setIsValid(null); // Reset validation when CAPTCHA changes
  }, []);

  // Handle form submission and CAPTCHA validation
  const handleSubmit = (e) => {
    e.preventDefault();
    if (captchaInput === captchaValue) {
      setIsValid(true);
      loadData()
    } else {
      setIsValid(false);

    }
  };
  const noResultComp = <div
    className="bg-blue-100 text-primary fw-bold p-2 form-title-card"
    style={{
      textAlign: "center",
      marginTop: "20px",
      fontSize: "22px",
      fontFamily: "time new roman",
      color: "#0013e9 !important",
    }}
  >
    <Row className="mt-3">
      <Col
        md={12}
        style={{
          color: "#0013e9 !important",
        }}
      >
        No Results Found
      </Col>
    </Row>
  </div>
  return (
    <>
      <Header title="Exam Results" backAction={true} />

      <div className="page-content-wrapper">
        <div className="container-sm">
          <WelcomeProfile />
          <Spin spinning={loader} tip="Loading...">

            <Card>
              <Row className="align-items-center">
                <Col md={12}>
                  <strong
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                      fontFamily: "time new roman",
                    }}
                  >
                    SEMESTER EXAM RESULTS - NOVEMBER 2024
                  </strong>
                </Col>
                <Col md={12}>
                  {viewData.length == 0 && (<Form onSubmit={handleSubmit} style={{ maxWidth: "350px", margin: "20px auto", padding: "20px", border: "1px solid #ddd", borderRadius: "10px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)" }}>
                    {/* CAPTCHA and Refresh */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <Captcha
                        ref={captchaRef}
                        charNum={6}
                        onChange={handleCaptchaChange}
                        height={50}
                      //backgroundColor="#ffffff" // White background
                      // fontColor="#000000" // Black text color
                      //fontSize={36} // Large and clear font
                      // noiseLevel={0} // Disable noise for clarity
                      />
                      <Button
                        variant="outline-secondary"
                        onClick={handleRefresh}
                        style={{
                          marginLeft: "10px",
                          padding: "5px 10px",
                          fontSize: "16px",
                          borderRadius: "5px",
                        }}
                      >
                        <i className="fa fa-redo"></i>
                      </Button>
                    </div>

                    {/* Input Field */}
                    <Form.Group controlId="captchaCode" className="mb-3">
                      <Form.Label style={{ fontWeight: "bold" }}>Enter the CAPTCHA Code</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter CAPTCHA"
                        value={captchaInput}
                        onChange={(e) => setCaptchaInput(e.target.value)}
                        isInvalid={isValid === false}
                        isValid={isValid === true}
                      />
                      <Form.Control.Feedback type="invalid">
                        CAPTCHA does not match. Please try again.
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* Submit Button */}
                    <Button
                      variant="secondary"
                      type="submit"
                      style={{
                        width: "100%",
                        fontSize: "16px",
                        fontWeight: "bold",
                        border: '1px solid blue',
                        padding: "10px",
                        borderRadius: "5px",
                        borderColor: "#007bff", // Primary blue color
                        color: "#007bff", // Text matches the border color
                        backgroundColor: "#f5eaea", // Ensures it's an outline button
                      }}
                    >
                      Submit
                    </Button>
                  </Form>)}

                </Col>
                {/* <Col md={6}>
                <li className="list-inline-item">
                  <Button
                    size="md"
                    variant="primary"
                    className="border-start fs-6"
                    style={{
                      marginTop: "20%",
                      marginLeft: "500%",
                      backgroundColor: "rgb(163, 26, 4)",
                    }}
                    onClick={(e) => downloadFile()}
                  >
                    <i className="fa-solid fa-file-arrow-down"></i>
                  </Button>
                </li>
              </Col> */}
              </Row>
              <Row>
                <Col xs={24} sm={12} lg={12} alignItems="center">
                  <Card
                    style={{
                      backgroundColor: "rgb(186 255 181 / 22%)",
                      boxShadow: "rgb(54 220 32 / 63%) 0px 4px 8px",
                      borderRadius: "8px",
                    }}
                    bodyStyle={{ padding: "15px" }}
                  >
                   {isValid && viewData.length > 0 && (<div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "10px",
                        color: "#107214",
                      }}
                    >
                      <CheckCircleOutline
                        style={{
                          fontSize: "24px",
                          color: "#52c41a",
                          marginRight: "8px",
                        }}
                      />
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          fontFamily: "time new roman",
                        }}
                      >
                        Result
                      </span>
                    </div>)}
                    {isValid && (<div
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontFamily: "Times New Roman, serif",
                          textAlign: "center",
                          border: "1px solid #ddd",
                          fontSize: "14px",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderBottom: "2px solid #ddd",
                            }}
                          >
                            <th style={{ padding: "8px", width: "5%" }}>S.No</th>
                            <th style={{ padding: "8px", width: "10%" }}>SEM</th>
                            <th style={{ padding: "8px", textAlign: "left", width: "auto" }}>
                              PAPER
                            </th>
                            <th style={{ padding: "8px", width: "10%" }}>INT.</th>
                            <th style={{ padding: "8px", width: "10%" }}>EXT.</th>
                            {viewData.some(
                              (item) =>
                                item.viva && item.viva !== 0 && item.viva !== null && item.viva !== ""
                            ) && <th style={{ padding: "8px", width: "10%" }}>VIVA</th>}
                            <th style={{ padding: "8px", width: "10%" }}>TOT.</th>
                            <th style={{ padding: "8px", width: "10%" }}>RESULT</th>
                            <th style={{ padding: "8px", width: "15%" }}>REMARKS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {viewData.map((item, i) => (
                            <tr
                              key={i}
                              style={{
                                borderBottom: "1px solid #ddd",
                              }}
                            >
                              <td style={{ padding: "8px" }}>{i + 1}</td>
                              <td style={{ padding: "8px" }}>{item.semester}</td>
                              <td
                                style={{
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {item.subject_name} ({item.subject_code})
                              </td>
                              <td style={{ padding: "8px" }}>{item.internal}</td>
                              <td style={{ padding: "8px" }}>{item.external}</td>
                              {viewData.some(
                                (item) =>
                                  item.viva && item.viva !== 0 && item.viva !== null && item.viva !== ""
                              ) && <td style={{ padding: "8px" }}>{item.viva ? item.viva : "-"}</td>}
                              <td style={{ padding: "8px" }}>{item.total}</td>
                              <td
                                style={{
                                  padding: "8px",
                                  fontWeight: "bold",
                                  color: item.result === "P" ? "#52c41a" : "#f5222d",
                                }}
                              >
                                {item.result === "F" ? "RA" : item.result}
                              </td>
                              <td style={{ padding: "8px" }}>{item.remarks}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                    </div>)}

                    {isValid && viewData.length === 0 && <>{noResultComp}</>}
                  </Card>
                </Col>
              </Row>
            </Card>

          </Spin>
        </div>
      </div>
    </>
  );
};
export default ExamResults;
